import { MIN_OF_DECIMAL_PLACES, MAX_OF_DECIMAL_PLACES, getConfigOf } from '@/services/formatter_services/enums/PERCENTAGE_CONFIG';
import FORMAT_VALIDATIONS from '@/services/formatter_services/enums/FORMAT_VALIDATIONS';

const formatNumberToPercentage = (value, locale = 'de', withSuffix = false) => {
  const { defaultValue } = getConfigOf(locale);
  if (typeof value !== 'number') { return defaultValue }

  const percentage = (parseFloat(value) * 100).toLocaleString(locale, {
    minimumFractionDigits: MIN_OF_DECIMAL_PLACES,
    maximumFractionDigits: MAX_OF_DECIMAL_PLACES,
  });

  return `${percentage}${withSuffix ? ' %' : ''}`;
}

const basicFormatNumberToPercentage = (value) => {
  const locale = 'de';
  if (typeof value !== 'number') { return undefined }

  const percentage = (parseFloat(value) * 100).toLocaleString(locale, {
    minimumFractionDigits: MIN_OF_DECIMAL_PLACES,
    maximumFractionDigits: MAX_OF_DECIMAL_PLACES,
  });

  return `${percentage}${'%'}`;
}

const formatPercentageToNumber = (value, locale = 'de') => {
  const { furtherReplacements } = getConfigOf(locale);

  if (FORMAT_VALIDATIONS.ONLY_NEGATIVE_PREFIX(value)) { return }
  let withoutSuffix = removePercentageSuffix(value);
  return parseFloat(furtherReplacements(withoutSuffix)) / 100;
}

export { formatNumberToPercentage, formatPercentageToNumber, basicFormatNumberToPercentage };

/*****************************
 * HELPERS
 *****************************/
const removePercentageSuffix = (value) => {
  return value.replace(/%/g, '').trim();
}
